module.exports = __webpack_public_path__ + "23b83d3c39946bd3a63c3878248acb8b.png";